import React from 'react';
import SubLayout from '../../components/Layout/SubLayout';
import strings from '../../components/Language';

import Refresh from './../../assets/images/icons/refresh.svg';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData, getUserData } from './../../components/Util';
import _ from 'lodash';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class MemberCenterScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			user_data: {},
			data: [],
			level_details: {},
			current_level_id: 0,
			current_level: {},
			next_level_id: 0,
			next_level: {},
			upgrade_details: {},
			is_load: false,
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			var user_data = getUserData();
			setTimeout(() => {
				this.setState({
					access_token: token,
					user_data: (user_data && user_data.data) ? user_data.data : {}
				});
				this.getData();
			});
		}
	}

	getData(isRefresh = false) {
		const { setLoading } = this.context;
		var self = this;
		self.setState({ is_load: true });
		if (self.state.access_token) {
			setLoading(true);
			axios({
				method: 'GET',
				url: api.account_progress_all,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage(),
				}
			}).then(function (ress) {
				if (ress.data && ress.data.error === 200) {
					self.setState({
						data: ress.data.data,
						current_level: (ress.data.data && ress.data.data.level_details && ress.data.data.level_details.current_level) ? ress.data.data.level_details.current_level : {},
						next_level: (ress.data.data && ress.data.data.level_details && ress.data.data.level_details.next_level) ? ress.data.data.level_details.next_level : {},
						upgrade_details: (ress.data.data && ress.data.data.upgrade_details) ? ress.data.data.upgrade_details : {},
						current_level_id: (ress.data.data && ress.data.data.level_details && ress.data.data.level_details.current_level && ress.data.data.level_details.current_level.id) ? ress.data.data.level_details.current_level.id : 0,
						next_level_id: (ress.data.data && ress.data.data.level_details && ress.data.data.level_details.next_level && ress.data.data.level_details.next_level.id) ? ress.data.data.level_details.next_level.id : 0,
					});
					var identifier = (ress.data.data && ress.data.data.level_details && ress.data.data.level_details.next_level && ress.data.data.level_details.next_level.identifier && (ress.data.data.level_details.next_level.id !== 0)) ? ress.data.data.level_details.next_level.identifier : "b6";
					if (identifier) {
						self.setState({
							upgrade_details_current: (ress.data.data && ress.data.data.upgrade_details && ress.data.data.upgrade_details[identifier]) ? ress.data.data.upgrade_details[identifier] : {},
						});
					}
					if (isRefresh) {
						toast.success(ress.data.message);
					}
					setLoading(false);
				} else {
					if (ress.data.validation && ress.data.validation.length !== 0) {
						_.forEach(ress.data.validation, function (value) {
							if (value[0]) {
								toast.error(value[0]);
							}
						});
					} else {
						toast.error(ress.data.message);
					}
					setLoading(false);
				}
				setTimeout(() => {
					self.setState({ is_load: false });
					setLoading(false);
				});
			}).catch(function (e) {
				setLoading(false);
				self.setState({ is_load: false });
			});
		}
	};

	render() {

		return (
			<SubLayout data={{ "title": strings.member_center }}>
				{!this.state.is_load ?
					<div style={{ marginBottom: 30 }}>

						<div style={{ margin: 10, textAlign: "-webkit-right" }}>
							{!this.state.is_load ?
								<div onClick={() => this.getData(true)} className='flex-center' style={{ cursor: "pointer", width: "fit-content" }}>
									<img style={{ zIndex: 9, marginRight: 5 }} src={Refresh} alt="" />
									<div style={{ color: "#8e8e8e" }}>{strings.refresh}</div>
								</div>
								:
								<div className='flex-center' style={{ cursor: "pointer", width: "fit-content", backgroundColor: "" }}>
									<img style={{ zIndex: 9, marginRight: 5 }} src={Refresh} alt="" />
									<div style={{ color: "#8e8e8e" }}>{strings.loading}</div>
								</div>
							}
						</div>

						<div className='level_box' style={{ marginBlock: 20 }}>
							<span onClick={() => this.setState({ current_level_id: 0, next_level_id: 1 })} className={`tab ${(this.state.current_level_id == 0) ? 'active' : ''}`}>B0</span>
							<span onClick={() => this.setState({ current_level_id: 1, next_level_id: 2 })} className={`tab ${(this.state.current_level_id == 1) ? 'active' : ''}`}>B1</span>
							<span onClick={() => this.setState({ current_level_id: 2, next_level_id: 3 })} className={`tab ${(this.state.current_level_id == 2) ? 'active' : ''}`}>B2</span>
							<span onClick={() => this.setState({ current_level_id: 3, next_level_id: 4 })} className={`tab ${(this.state.current_level_id == 3) ? 'active' : ''}`}>B3</span>
							<span onClick={() => this.setState({ current_level_id: 4, next_level_id: 5 })} className={`tab ${(this.state.current_level_id == 4) ? 'active' : ''}`}>B4</span>
							<span onClick={() => this.setState({ current_level_id: 5, next_level_id: 6 })} className={`tab ${(this.state.current_level_id == 5) ? 'active' : ''}`}>B5</span>
							<span onClick={() => this.setState({ current_level_id: 6, next_level_id: '' })} className={`tab ${(this.state.current_level_id == 6) ? 'active' : ''}`}>B6</span>
						</div>
						<div className='offset-md-4 col-md-4 trad_bot' style={{ position: "relative" }}>
							<div className="mc-card">

								<div className='text-center text_center_all'>
									{this.state.current_level_id == 0 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B1"</div>
												<div className='' style={{ fontSize: 12 }}>{strings.please_activate_your_CTS_bot}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B0 {strings.membership_rights}</div>
											</div>
											<div className='' style={{ fontSize: 12 }}>{strings.please_activate_ctsbot_for_more_membership_rights}</div>
										</>
										: null}
									{this.state.current_level_id == 1 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B2"</div>
												<div className='' style={{ fontSize: 12 }}>- 3 {strings.active_direct} B1 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 30 {strings.active_team_members}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B1 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1_20}</div>
											</div>
										</>
										: null}
									{this.state.current_level_id == 2 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B3"</div>
												<div className='' style={{ fontSize: 12 }}>- 5 {strings.active_direct} B1 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 3 {strings.active_direct} B2 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 150  {strings.active_team_members}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B2 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_3}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_4}</div>
											</div>
										</>
										: null}
									{this.state.current_level_id == 3 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B4"</div>
												<div className='' style={{ fontSize: 12 }}>- 8 {strings.active_direct} B1 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 3 {strings.active_direct} B3 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 400 {strings.active_team_members}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B3 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_6}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_6}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_7}</div>
											</div>
										</>
										: null}
									{this.state.current_level_id == 4 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B5"</div>
												<div className='' style={{ fontSize: 12 }}>- 12 {strings.active_direct} B1 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 3 {strings.active_direct} B4 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 800 {strings.active_team_members}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B4 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_6}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b4_bot_fee_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b4_bot_fee_pool_desc_1}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_6}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_7}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b4_profit_sharing_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b4_profit_sharing_pool_desc_1}</div>
											</div>
										</>
										: null}
									{this.state.current_level_id == 5 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level} "B6"</div>
												<div className='' style={{ fontSize: 12 }}>- 17 {strings.active_direct} B1 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 3 {strings.active_direct} B5 {strings.members}</div>
												<div className='' style={{ fontSize: 12 }}>- 1500 {strings.active_team_members}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B5 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_6}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b5_bot_fee_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b5_bot_fee_pool_desc_1}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b5_bot_fee_pool_desc_2}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_6}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_7}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b5_profit_sharing_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b5_profit_sharing_pool_desc_1}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b5_profit_sharing_pool_desc_2}</div>
											</div>
										</>
										: null}
									{this.state.current_level_id == 6 ?
										<>
											<div className='mb-3 level_diff_border pb-3'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>{strings.how_to_qualify_next_level}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.you_are_now_highest_level_at_B6}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 16, fontWeight: "bold" }}>B6 {strings.membership_rights}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.bot_activation_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.bot_activation_earning_level_6}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b6_bot_fee_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b6_bot_fee_pool_desc_1}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b6_bot_fee_pool_desc_2}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.profit_sharing_earning}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_1}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_2}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_3}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_4}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_5}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_6}</div>
												<div className='' style={{ fontSize: 12 }}>{strings.profit_sharing_earning_level_7}</div>
											</div>
											<div className='mb-2'>
												<div className='mc-text-title' style={{ fontSize: 14, fontWeight: "bold" }}>{strings.b6_profit_sharing_pool}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b6_profit_sharing_pool_desc_1}</div>
												<div className='width-memer-center' style={{ fontSize: 12 }}>{strings.b6_profit_sharing_pool_desc_2}</div>
											</div>
										</>
										: null}
								</div>
							</div>
						</div>
					</div>
					: null
				}
			</SubLayout >
		);
	}
}

export default MemberCenterScreen;